import React from 'react'

export default function Terms() {
    return (
        <div className='h-full w-full display-flex justify-center items-center mx-auto my-auto'>
            <div className='flex w-auto h-auto mt-8 pb-8 pt-8 justify-center items-center flex-col'>
                <h1 className='text-4xl font-bold mt-4'>Introduction</h1>
                <p>
                    These Terms of Service (the "Terms") represent an agreement between
                    TenderTalk (the “App,” “Services,” “we,” or “us”) and you (“users”). If you
                    access, use, subscribe, or pay for the Services described below, you
                    provide your consent to the terms, conditions, prices, and charges defined
                    in this Agreement. In case you do not agree to the Terms, please do not
                    use the App.
                </p>

                <h2 className='text-4xl font-bold mt-4'>Eligibility</h2>
                <p>
                    By accessing, using, or subscribing for TenderTalk, you confirm that you
                    have read and accepted the Terms, and that all data that you provided to
                    us is yours and true. To sign up and use the App, EU countries and UK
                    citizens must be 16 years or over.
                </p>

                <h2 className='text-4xl font-bold mt-4'>Service Description</h2>
                <p>
                    TenderTalk is a AI chatbot that allows its users to chat with AI profiles.
                </p>

                <p>TenderTalk allows its users to:</p>
                <ul>
                    <li>-Chat with AI Profiles.</li>
                    <li>-Use the app's interface effortlessly</li>
                    <li>-Get a free trial period for 3 days</li>
                </ul>

                <h2 className='text-4xl font-bold mt-4'>Subscriptions</h2>
                <p>
                    We provide a Weekly Subscription Plan with a three-day trial period for
                    the first subscription.
                </p>

                <p>
                    You purchase your Subscription for your personal use only. You may not
                    provide any access to it, no to individuals nor to legal entities.
                </p>

                <p>
                    Our software may be downloaded and installed on an unlimited number of
                    your devices.
                </p>

                <p>
                    The Subscriptions have autorenewal when your current Subscription period
                    ends. The auto-renewed Subscription will be of the same duration as the
                    original one.
                </p>

                <p>
                    From time to time, we may change the prices of Subscriptions and other
                    terms without advance notice. The prices will be posted on the App.
                </p>

                <p>
                    For any questions regarding your Subscriptions, you can contact us via
                    <a href="[MAIL]">[MAIL]</a>.
                </p>

                <h2 className='text-4xl font-bold mt-4'>Subscription Cancellation</h2>
                <p>
                    If you want to cancel your Subscription, you should cancel it on Apple App
                    Store or Google Play. To find out more, please read our ‘Refund Policy’.
                </p>

                <h2 className='text-4xl font-bold mt-4'>Usage Restrictions</h2>
                <p>
                    Anyone that signs in and uses TenderTalk agrees to use the app for parental
                    control use only. The App must not be used in a fraudulent, abusive, or
                    unlawful manner. You confirm that you are 16 years old or over, as the App
                    is not designed for children under 16.
                </p>

                <h2 className='text-4xl font-bold mt-4'>Unauthorized Use</h2>
                <p>
                    You are the one who ensures confidential keeping of your account
                    credentials. You are solely responsible to TenderTalk for all your
                    activities occurring under your account, preventing it from unauthorized
                    use, and for any and all damages that may be caused by such unauthorized
                    use. You should notify us at <a href="[MAIL]">[MAIL]</a> if you believe
                    that there was known or suspected security breach.
                </p>

                <h2 className='text-4xl font-bold mt-4'>Privacy</h2>
                <p>
                    We recognize and respect TenderTalk users’ privacy and ensure it by sticking
                    to the terms described in our ‘Privacy Policy’. Please pay attention that
                    we may, however, be exposed to your chats, but we do not store or make any
                    use of this information, and shall not be liable to you in any way with
                    respect to the above.
                </p>

                <h2 className='text-4xl font-bold mt-4'>Permission to Access Data and Usage</h2>
                <p>
                    TenderTalk does not collect or use any of the user's data from their
                    TenderTalk Account for any purpose other than the proper functioning of the
                    software. By using TenderTalk, you agree to grant the necessary permissions
                    to access account in order for the software to function
                    properly. You understand and acknowledge that the software may have access
                    to all of your data on the account, but it does not collect or use any of
                    this data for any other purpose.
                </p>

                <h2 className='text-4xl font-bold mt-4'>Disclaimers</h2>
                <p>
                    TenderTalk services are provided on an "as is" basis, with no warranty of
                    any type. We do not give any guarantee that the App will meet your
                    personal expectations and requirements, or that all the time it will be
                    uninterrupted, available, secure, and error-free.
                </p>

                <p>
                    BY ACCESSING, USING, SUBSCRIBING, OR PAYING FOR THE SERVICES, YOU AGREE
                    THAT TenderTalk SERVICES ASSUME NO LIABILITY UNDER THESE TERMS OR OTHERWISE
                    FOR ANY HARM, DAMAGE OR EXPENSE CAUSED TO THE USER, SUBSCRIBER OR ANY
                    THIRD PARTY, WHATEVER CAUSED DUE TO THE SUBSCRIBER'S ACTS OR OMISSIONS OR
                    DUE TO ANY THIRD PARTY'S ACTS OR OMISSIONS, REGARDING THE SUBSCRIBER
                    ITSELF, ITS USAGE OF THE WHATSAPP APP, ITS CONTACTS AND THEIR USE OF
                    WHATSAPP APP, OR ANY OTHER INFORMATION AVAILABLE, WHATEVER THROUGH THE
                    REGULAR USAGE OF TenderTalk SUBSCRIPTION OR DUE TO ANY OTHER UNLAWFUL ACT
                    AGAINST TenderTalk, CYBER ATTACKS ETC.
                </p>

                <p>
                    TenderTalk SERVICES ALSO ASSUME NO LIABILITY UNDER THESE TERMS OR OTHERWISE
                    FOR ANY INDIRECT, CONSEQUENTIAL, EXEMPLARY, SPECIAL, INCIDENTAL OR
                    PUNITIVE DAMAGES.
                </p>

                <p>
                    THESE LIMITATIONS APPLY TO ALL CAUSES OF ACTION IN THE AGGREGATE,
                    INCLUDING, BUT NOT LIMITED TO, BREACH OF CONTRACT; BREACH OF WARRANTY,
                    NEGLIGENCE, STRICT LIABILITY, MISREPRESENTATIONS, AND OTHER TORTS.
                </p>

                <p>ALL AND ANY LIABILITY RESTS WITH THE USER OR SUBSCRIBER.</p>

                <h2 className='text-4xl font-bold mt-4'>Indemnity</h2>
                <p>
                    Be aware that you will indemnify and hold harmless the App, and all people
                    standing against it, i.e., as its directors, employees, officers, agents,
                    and partners from and against any damages, liabilities, losses, demands,
                    disputes, claims, costs, and expenses including, without limitation, legal
                    and accounting fees, which may appear after your access or use of the App,
                    or if you have violated any of these Terms.
                </p>

                <h2 className='text-4xl font-bold mt-4'>Terms Changes</h2>
                <p>
                    We reserve the right to make any changes in the Terms of Service at any
                    time. Once posted, the changes will become effective. Please check the
                    Terms of Service for updates regularly.
                </p>

                <h2 className='text-4xl font-bold mt-4'>Contact us</h2>
                <p>
                    You are welcome to ask any questions related to the Terms of Service by
                    emailing us at <a href="[MAIL]">[MAIL]</a>.
                </p>
            </div>
        </div>
    )
}
